import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-sospensioni',
  templateUrl: './sospensioni.component.html',
  styleUrls: ['./sospensioni.component.css']
})
export class SospensioniComponent implements OnInit {
  listFields:any[]=[];

  pageTitle:string='';
  listParams:any={};
  struttureList:any[]=[];
  newRecordUrl:string='';
  editRecordUrl:string='';
  deleteRecordUrl:string='';
 
  isLoading=true;

  struttura_id:number=0;
 
  constructor(
      private apiService: ApiService,
      private globalService: GlobalService,
  ) { }

  ngOnInit(): void {
  
    this.apiService.get('mensa/getstrutture',{}).subscribe((data)=>{
      this.struttureList=data.Result;
      if(this.globalService.loggedUser.struttura_id){
        this.struttura_id=this.globalService.loggedUser.struttura_id;
        
      } else {
        this.struttura_id=JSON.parse(localStorage.getItem('mensa_struttura_id'));
      
      }
      if(!this.struttura_id && this.struttureList.length>0){
        this.struttura_id=this.struttureList[0].value;
      }
      if(this.struttura_id){ 
        this.listParams.struttura_id=this.struttura_id;
        let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
        this.pageTitle="Struttura "+f[0].text;
        this.pageTitle="Sospensione servizio mensa per: "+f[0].text;
        this.newRecordUrl='dashboard/gestionemensa/sospensioni/sospensioni-edit/new/'+f[0].text+'/'+this.struttura_id+'/';
        this.editRecordUrl='dashboard/gestionemensa/sospensioni/sospensioni-edit/update/'+f[0].text+'/'+this.struttura_id+'/';
        this.deleteRecordUrl='mensa/mensa_sospensione_delete';
        localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
        this.changeStruttura({value:this.struttura_id});
      }
       this.isLoading=false;
    });
    this.listFields= [
      {
        field:'id',
        type:'edit',
        pSortableColumnDisabled:true,
        style:'width:50px;text-align:center;'
      },
      {
        field:'motivazione',
        type:'field',
        header:'Motivazione'
      },
      {
        field:'dal_giorno',
        type:'date',
        header:'Dal giorno',
        style:'width:150px;text-align:center;'
      },
      {
        field:'al_giorno',
        type:'date',
        header:'Al giorno',
        style:'width:150px;text-align:center;'
      },
         {
        field:'id',
        type:'delete',
        pSortableColumnDisabled:true,
        style:'width:50px;text-align:center;'
      }
  
    ];
  }

 userCannotChangeStruttura(){
     if(this.globalService.loggedUser.struttura_id){
      return true;
     } else {
      return false;
     }
  }

  changeStruttura(event=null){
  if(event){
      this.struttura_id=event.value;
    }
    this.listParams.struttura_id=this.struttura_id;
    let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
    localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
    if(!this.isLoading){
      window.location.reload();
    }
  
  }

}
